import * as Tooltip from '@radix-ui/react-tooltip'
import { styled, keyframes } from 'stitches.config'

const slideDown = keyframes({
  '0%': { opacity: 0, transform: 'translateY(-10px)' },
  '100%': { opacity: 1, transform: 'translateY(0)' },
})

const slideUp = keyframes({
  '0%': { opacity: 0, transform: 'translateY(10px)' },
  '100%': { opacity: 1, transform: 'translateY(0)' },
})

export const TooltipContent = styled(Tooltip.Content, {
  maxWidth: '200px',
  borderRadius: '$1',
  padding: '$1 $2',
  fontSize: '$small',
  lineHeight: '$small',
  backgroundColor: '$tertiary-900',
  color: '$accent-white',
  animationDuration: '250ms',
  animationTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)',

  '&[data-side="top"]': {
    animationName: slideUp,
  },

  '&[data-side="bottom"]': {
    animationName: slideDown,
  },

  '@bp1': {
    maxWidth: '386px',
  },
})

export const TooltipArrow = styled(Tooltip.Arrow, {
  fill: '$tertiary-900',
})
